<template>
  <Plotly
    :data="computedData"
    :layout="computedLayout"
    :display-mode-bar="displayModeBar"
    :displaylogo="false"
    :toImageButtonOptions="toImageButtonOptions"
    :mode-bar-buttons-to-remove="[
      'toggleSpikelines',
      'hoverClosestCartesian',
      'hoverCompareCartesian',
      'select2d',
      'lasso2d',
    ]"
    v-on="$listeners"
  />
</template>

<script>
import deepmerge from "deepmerge";
import { Plotly } from "vue-plotly";

const logo = require("@/assets/rex-logo.png");

const acelerexLogo = {
  xref: "paper",
  yref: "paper",
  x: 1,
  y: 0.05,
  sizex: 0.09,
  sizey: 0.09,
  xanchor: "right",
  yanchor: "bottom",
  opacity: 0.6,
  layer: "below",
  source: `${window.location.protocol}//${window.location.host}${logo}`,
  alt: "rex-logo",
};

export default {
  name: "ChartPlotly",
  components: { Plotly },
  mixins: [],
  props: {
    data: { type: Array, required: false, default: () => [] },
    layout: { type: Object, require: false, default: () => ({}) },
    showModeBar: { type: [Boolean, String], required: false, default: "hover" },
    toImageButtonOptions: {
      type: Object,
      required: false,
      default: () => ({ format: "png" }),
    },
    displayModeBar: {
      type: [Boolean, String],
      required: false,
      default: "hover",
    },
  },
  data() {
    return {};
  },
  computed: {
    computedLayout() {
      const merged = deepmerge(
        {
          title: { font: { size: 14 } },
          images: [acelerexLogo],
        },
        this.layout
      );

      const hasLogo = merged.images.some((el) => el.alt === "rex-logo");
      if (!hasLogo) {
        // images don't have logo.
        merged.images.concat([acelerexLogo]);
      }

      return merged;
    },
    computedData() {
      return this.data.map((v) => deepmerge({ line: { width: 1.5 } }, v));
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
